module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Wrap_Tofu.b42f0ee7.jpg";